module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_border-a93842c8663183d624848206159f4ed2.gif";